import { IFilterContent } from '../lists/listTypes';

export interface ITaxesFiltersState {
    Name: IFilterContent;
    IdSupplierHotel: IFilterContent;
    IdSupplierHotelRoomType: IFilterContent;
    IdSupplierHotelMealPlan: IFilterContent;
    IdSupplierHotelRatePlan: IFilterContent;
    FromDate: IFilterContent;
    ToDate: IFilterContent;
}

export interface ITaxComplementaryDataOption {
    Id: string;
    Name: string;
    IdCurrency?: number;
    Key?: string;
    Icon: string;
}

export interface IComplementaryDataState {
    data: ITaxComplementaryDataOption[];
    isLoading: boolean;
    error: string | null;
    count: number;
}

export interface ITaxState {
    Id: string;
    Enabled: boolean;
    Name: string;
    Amount: number;
    Priority: number;
    Description: string;
    IdSupplierHotel: number;
    SupplierHotel: string;
    IdSupplierHotelRoomType: number;
    SupplierHotelRoomType: string;
    IdSupplierHotelMealPlan: number;
    SupplierHotelMealPlan: string;
    IdSupplierHotelRatePlan: number;
    SupplierHotelRatePlan: string;
    IdSupplierTaxType: number;
    SupplierTaxType: string;
    SupplierTaxTypeKey: string;
    IdSupplierTaxCalculationType: number;
    SupplierTaxCalculationType: string;
    SupplierTaxCalculationTypeKey: string;
    IdSupplierTaxCalculationRuleType: number;
    SupplierTaxCalculationRuleType: string;
    SupplierTaxCalculationRuleTypeKey: string;
    IdSupplementCalculationType: number;
    SupplementCalculationType: string;
    SupplementCalculationTypeKey: string;
    IdCurrency: number;
    Currency: string;
    EffectivePerson: number;
    FromAge: number;
    ToAge: number;
    FromDate: Date | null | string;
    OnlyAdults: boolean;
    OnlyChildren: boolean;
    ToDate: Date | null | string;
    LastUpdate: Date | null | string;
    Deleted?: boolean;
}

export interface ParsedRuleType {
    subject: string;
    frequency: string;
    original: ITaxComplementaryDataOption;
}

export enum TaxListViewType {
    TABLE = 'TABLE',
    CALENDAR = 'CALENDAR',
}
